import component from './en-US/component';
import dashboard from './en-US/dashboard';
import globalHeader from './en-US/globalHeader';
import menu from './en-US/menu';
import pages from './en-US/pages';
import products from './en-US/products';
import orders from './en-US/orders';
import admin from './en-US/admin';
import pwa from './en-US/pwa';
import settingDrawer from './en-US/settingDrawer';
import settings from './en-US/settings';
import account from './en-US/account';

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
  
  // Login page
  'pages.login.subtitle': 'E-commerce Operations Management Platform',
  'pages.login.username.placeholder': 'Please enter username',
  'pages.login.password.placeholder': 'Please enter password',
  'pages.login.username.required': 'Please enter username!',
  'pages.login.password.required': 'Please enter password!',
  'pages.login.success': 'Login successful!',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.user.not.exist': 'User does not exist',
  'pages.login.account.disabled': 'User account is inactive or suspended',
  'pages.login.rememberMe': 'Remember me',
  'app.request.error': 'Request failed',
  'media.preview': 'Preview',
  'media.videoPreview': 'Video Preview',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...dashboard,
  ...products,
  ...orders,
  ...admin,
  ...account,
};
